import { LINKS, PROFILE } from "../../data/content";

const SOCIALS = [
  { label: "LinkedIn", href: LINKS.linkedin },
  { label: "Website", href: LINKS.website },
  { label: "YouTube", href: LINKS.youtube },
  { label: "Press", href: LINKS.press },
];

export const Footer = () => (
  <footer className="relative border-t border-white/10 bg-[#103a2a] py-16">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <div className="flex flex-col justify-between gap-10 md:flex-row md:items-end">
        <div>
          <h3 className="font-display text-5xl font-extrabold text-white md:text-7xl">
            {PROFILE.first}
            <br />
            {PROFILE.last}
            <span className="text-[#c9a24e]">.</span>
          </h3>
          <p className="mt-4 max-w-xs text-sm text-[#52525b]">
            Operations · Business Growth · Commercial Leadership — {PROFILE.location}.
          </p>
        </div>
        <div className="flex flex-wrap gap-x-10 gap-y-4">
          {SOCIALS.map((s) => (
            <a
              key={s.label}
              data-testid={`footer-${s.label.toLowerCase()}`}
              href={s.href}
              target="_blank"
              rel="noreferrer"
              className="group relative text-sm uppercase tracking-[0.2em] text-[#a1a1aa] transition-colors hover:text-white"
            >
              {s.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#c9a24e] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>
      </div>
      <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-8 text-xs text-[#52525b] md:flex-row md:items-center">
        <span>© {new Date().getFullYear()} Naresh Gabriel. All rights reserved.</span>
        <span className="uppercase tracking-[0.2em]">Perth · Singapore · Asia-Pacific</span>
      </div>
    </div>
  </footer>
);
